import { createSlice } from "@reduxjs/toolkit";

const brandSlice = createSlice({
  name: "brand",
  initialState: {
    brandArray: [], // Store API response here
  },
  reducers: {
    setbrand(state, action) {
      state.brandArray = action.payload; // Update state correctly
    },
  },
});

export const { setbrand } = brandSlice.actions;
export default brandSlice.reducer;
